<template>
  <div id="BulletinArticle">
    <div class="BulletinArticle-inner">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{$t('message.sy')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Bulletin' }">{{$t('message.gg')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('message.wzmc')}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="BulletinArticle-content">
        <p class="BulletinArticle-title">{{$t('message.gg')}}</p>
        <p class="BulletinArticleTitle">{{title}}</p>
        <p class="BulletinArticleTime">{{$t('message.fbsj')}}:<span style="margin-left:10px;">{{time}}</span></p>
        <div class="BulletinArticleContent" v-html="article"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:"BulletinArticle",
  data:function(){
    return{
      title:'',
      article:'',
      time:''
    }
  },
  created(){
    this.$store.dispatch('getArticle',this.$route.query.id).then(res => {
      this.title = res.data.title
      this.article = res.data.content
      this.time = res.data.release_time
    })
  },
  watch:{
    '$route':function(val,oldval){
      this.$store.dispatch('getArticle',this.$route.query.id).then(res => {
        this.title = res.data.title
        this.article = res.data.content
        this.time = res.data.release_time
      })
    }
  }
}
</script>

<style lang="scss">
#BulletinArticle{
  background-color: #f6f6f6;
  padding: 0px 40px 40px 40px;
  // padding: 20px 40px 40px 40px;
  .BulletinArticle-inner{
    margin: 0 auto;
    // max-width: 1320px;
    // min-width: 1120px;
    width: 1200px;
    position: relative;
    .el-breadcrumb{
      line-height: 40px;
      .el-breadcrumb__item{
        .el-breadcrumb__separator{
          color: #282828 !important;
        }
        .el-breadcrumb__inner{
          color: #0086d1 !important;
          font-weight: normal !important;
        }
        .el-breadcrumb__inner.is-link{
          color: #282828 !important;
        }
        .el-breadcrumb__inner.is-link:hover{
          text-decoration: underline;
        }
      }
    }
    .BulletinArticle-content{
      border-radius: 6px;
      background-color: #fff;
      -webkit-border-radius: 6px;
      padding: 20px 40px 40px 40px;
      .BulletinArticle-title{
        color: #0086d1;
        font-size: 26px;
        line-height: 40px;
        position: relative;
        padding-bottom: 10px;
        border-bottom: 2px solid #0086d1;
      }
      .BulletinArticleTitle{
        color: #282828;
        font-size: 18px;
        overflow: hidden;
        margin-top: 10px;
        line-height: 38px;
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .BulletinArticleTime{
        color: #282828;
        font-size: 16px;
        line-height: 36px;
        text-align: center;
        margin-bottom: 10px;
      }
      .BulletinArticleContent{
        width: 100%;
      }
      .BulletinArticleContent:after{content:"";display:block;clear:both;}
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BulletinArticle/index.vue


// WEBPACK FOOTER //
// src/views/BulletinArticle/index.vue